import { useState } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

import Modal from 'app/components/Modal';
import Form from 'app/components/Form';

import {
  updateFeatureFlags,
  updateAccount,
  getAccount
} from 'app/services/accounts';

const FeatureFlagsForm = props => {
  const {
    isOpen,
    onClose,
    account,
    updateRow,
    setLastUpdate
  } = props;

  const formatLabel = flag => {
    return flag.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  let fields = Object.keys(account.feature_flags).map(flag => {
    if (flag != 'account_id') {
      return {
        name: flag,
        label: formatLabel(flag),
        type: 'checkbox',
        value: account.feature_flags[flag]
      }
    } else {
      return { name: 'account_id', type: 'hidden', value: account.id }
    }
  });

  const onSubmit = async params => {
    await updateFeatureFlags(params)

    // set the account's accountType to "custom" (-1)
    let updatedAccount = await updateAccount(account.id, { accountType: -1 });

    // refresh account in grid and modal
    updateRow(updatedAccount);

    // refresh the account form (this isn't working yet)
    setLastUpdate(Date.now());
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Feature Flags"
    >
      <Form
	header="Edit"
	fields={fields}
	onClose={onClose}
	onSubmit={onSubmit}
      />
    </Modal>
  )
}

export default FeatureFlagsForm;
